import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../../services/auth.service'

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    return (
        <Route {...rest} render={props => (
            AuthService.getCurrentUser() && restricted ?
                <Redirect to="/statistics" />
            : <Component {...props} />
        )} />
    );
};

export default PublicRoute;